import firebase from "firebase";
import DB_PATH from "../DB_PATH";
import { Notification } from "../../types/Notification";

const useSaveNotification = () => {
  const saveNotification = async (notification: Notification) => {
    // Validate that the notification has a title and description.
    if (!notification.title || !notification.description) {
      console.error("Notification must have a title and description.");
      throw new Error("Notification must have a title and description.");
    }

    // Get the Firestore instance (Firebase v8)
    const db = firebase.firestore();
    // Reference the notifications collection
    const notificationsCollection = db.collection(DB_PATH.NOTIFICATION);

    console.log("Saving Notification:", notification);

    // Add a timestamp if not provided
    const notificationWithTimestamp = {
      ...notification,
      createdAt: notification.createdAt || Date.now(), // Add timestamp if missing
    };

    // Add the notification to Firestore; .add() returns a promise resolving to a DocumentReference
    const docRef = await notificationsCollection.add(notificationWithTimestamp);

    // Include the Firestore-generated ID in the notification object
    const notificationWithId = {
      ...notificationWithTimestamp,
      id: docRef.id, // Add the Firestore-generated ID
    };

    // Update the document to include the ID field
    await notificationsCollection.doc(docRef.id).set(notificationWithId);

    // Return the updated notification object with the ID
    return notificationWithId;
  };

  return saveNotification;
};

export default useSaveNotification;
